import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { volunteerStatsPublicControllerGetVolunteerOfTheMonth } from '@klubovna/api-client';
import { VolunteerOfMonthDto, VolunteerOfMonthMetric } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VolunteersApiService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject(ApiConfiguration);

  getVolunteerOfMonth(metric: VolunteerOfMonthMetric): Observable<VolunteerOfMonthDto> {
    return volunteerStatsPublicControllerGetVolunteerOfTheMonth(this.http, this.apiConfig.rootUrl, { metric })
      .pipe(map(response => response.body));
  }
}
